<template>
  <div class="modal modal-overlay" @click.self="$emit('close')">
    <div class="maincont" id="Data_download">
      <div id="download">
        <div id="download_set">

          <h2>電力計測データ</h2>

          <dl class="display_date">

            <dt>取得開始</dt>
            <dd>
              <datepicker
                :minimum-view="'day'"
                format="yyyy年MM月dd月"
                :language="ja"
                :disabled-dates="this.dayInfo.disabled.start"
                style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                v-model="getStartDay"
              ></datepicker>
            </dd>

            <span>～</span>

            <dt>取得終了</dt>
            <dd>
              <datepicker
                :minimum-view="'day'"
                format="yyyy年MM月dd日"
                :language="ja"
                :disabled-dates="this.dayInfo.disabled.end"
                style="border: 2px solid rgb(92, 161, 214);border-radius: 2px;"
                v-model="getEndDay"
              ></datepicker>
            </dd>
          </dl>

          <div id="submit_area">
            <input type="button" id="submit" class="submit" value="帳票ダウンロード" @click="onDownload">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import Datepicker from "vuejs-datepicker";
import {ja} from 'vuejs-datepicker/dist/locale'

moment.tz.setDefault("Asia/Tokyo");
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

export default {
  name: "download-dialog",
  props: ["account", "loginType", "start", "end"],
  components: {
    Datepicker
  },
  data: function() {
    return {
      ja: ja,
      dayInfo: {
        disabled: {
          start: { from: null, to: null },
          end  : { from: null, to: null }
        },
        param: {
          start: null,
          end  : null
        }
      }
    };
  },

  computed: {
    getStartDay: {
      get: function() {
        return moment.utc(this.dayInfo.param.start, "YYYY/MM/DD").toISOString();
      },
      set: function(newValue) {
        this.dayInfo.param.start = moment(newValue);
        this.setDayRange();
      }
    },

    getEndDay: {
      get: function() {
        return moment.utc(this.dayInfo.param.end, "YYYY/MM/DD").toISOString();
      },
      set: function(newValue) {
        this.dayInfo.param.end = moment(newValue);
        this.setDayRange();
      }
    },   
  },

  mounted: function() {
    this.dayInfo.param.start   = moment(this.start);
    this.dayInfo.param.end     = moment(this.end);
    this.setDayRange();
  },

  methods: {
    setDayRange: function() {
      this.dayInfo.disabled.start = {
        to  : new Date(moment().add(-1, "year").year(), moment().add(-1, "year").month(), moment().add(-1, "year").date()),
        from: new Date(this.dayInfo.param.end.year(), this.dayInfo.param.end.month(), this.dayInfo.param.end.date() + 1)
      }
      this.dayInfo.disabled.end = {
        to  : new Date(this.dayInfo.param.start.year(), this.dayInfo.param.start.month(), this.dayInfo.param.start.date()),
        from: new Date(moment().year(), moment().month(), moment().date() + 1)
      }
    },


    onDownload: function() {      
      let api   = "power_measure_data_download";
      let param = { 
        login_type: this.loginType, 
        start_date: this.dayInfo.param.start.format("YYYY/MM/DD"), 
        end_date: this.dayInfo.param.end.format("YYYY/MM/DD")
      };

      this.$axios
        .post(`/srv/api/${api}/${this.account}`, param, {
          withCredentials: true,
          responseType: "blob",
          exposedHeaders: ["Content-Disposition"]
        })
        .then(response => {
          console.log(response);
          console.log(response.headers["content-disposition"]);
          let fileName = "";
          const contentDisposition = response.headers["content-disposition"];
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, "");
          }
          console.log(fileName);

          if (response.headers["content-type"].indexOf("application/json") != -1) {
            alert("ダウンロードできませんでした");
            return;
          }
          const dl = document.getElementById("downloadLink");
          if (dl != undefined) dl.parentNode.removeChild(dl);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("id", "downloadLink");
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.$emit("close");
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
.modal.modal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal .modal-window {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.modal .modal-content {
  padding: 10px 20px;
}

.modal .modal-footer {
  background: #ccc;
  padding: 10px;
  text-align: right;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;

  /* .modal-window {
   transition: opacity 0.4s, transform 0.4s;
 } */
}

.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  /* .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  } */
}

.download-type {
  width: 100px;
}

</style>